/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Addedbyme3Inputs */

const en_coinvestments_prospects_addedbyme3 = /** @type {(inputs: Coinvestments_Prospects_Addedbyme3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added by Me`)
};

/**
* | output |
* | --- |
* | "Added by Me" |
*
* @param {Coinvestments_Prospects_Addedbyme3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_addedbyme3 = /** @type {((inputs?: Coinvestments_Prospects_Addedbyme3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Addedbyme3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_addedbyme3(inputs)
});
export { coinvestments_prospects_addedbyme3 as "coInvestments_prospects_addedByMe" }